import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import {
  legalDocumentBodySx,
  legalDocumentCardSx,
  legalPageContainerSx,
  legalPageHeaderSx,
  legalPageMetaSx,
  legalPageShellSx,
  legalPageTitleSx,
} from "./styles";

const CreatorAgreement: React.FC<{}> = () => {
  useEffect(() => {
    document.title = "Creator Agreement - OmMuse";
  }, []);

  return (
    <Box sx={legalPageShellSx}>
      <Box sx={legalPageContainerSx}>
        <Box sx={legalPageHeaderSx}>
          <Typography sx={legalPageTitleSx}>Creator Agreement</Typography>
          <Typography sx={legalPageMetaSx}>
            Last Updated: April 12, 2021
          </Typography>
        </Box>
        <Box sx={legalDocumentCardSx}>
          <Box sx={legalDocumentBodySx}>
            <ul>
              <li>
                <strong>Creators</strong>
              </li>
            </ul>
            <p>
              This OmMuse Creator Agreement (&ldquo;Agreement&rdquo;) sets forth the
              terms and conditions for you (&ldquo;You&rdquo;, &ldquo;Your&rdquo;, or
              &ldquo;Creator&rdquo;), a Creator that is licensing content including
              but not limited to music or audio recordings (collectively
              &ldquo;Creator Content&rdquo;) for sale on the OmMuse platform
              (&ldquo;Platform&rdquo; as defined in the User Terms of Use). This is an
              Agreement made between you and OmMuse (&ldquo;OmMuse&rdquo;) the
              provider of the Platform. You must agree to this Agreement and the
              OmMuse User Terms of Use along with the OmMuse Privacy Policy. Where no
              definitions are given in this Agreement, please refer to the OmMuse User
              Terms of Use (&ldquo;TOU&rdquo;). Where the OmMuse Terms of Use and this
              Agreement directly conflict, this Agreement shall control. You
              acknowledge and agree that OmMuse is merely providing a technology
              Platform that allows you to connect with Users and has no liability to
              you for any Creator Content sold. Please read all portions of this
              Agreement carefully.&nbsp;
            </p>
            <p>THIS AGREEMENT CONTAINS ARBTRATION AND CLASS ACTION WAIVERS</p>
            <ol>
              <li>
                <strong>Creator Accounts</strong>
              </li>
            </ol>
            <p>
              In order for Creators to offer Creator Content you must create a Creator
              account. You must fully complete the registration process by providing
              us with your current, complete, truthful, and accurate information as
              prompted by the applicable registration form and you must be 18 years of
              age or older to create a Creator account. Where required, OmMuse may
              also assign you a username and password. You are entirely responsible
              for maintaining the confidentiality of your password and account and for
              any and all activities that occur under your account. You agree to
              notify OmMuse immediately of any unauthorized use of your account or any
              other breach of security. You may be offered various Creator account
              options and you are solely responsible for selecting the proper account
              type. OmMuse will not be liable for any losses you incur as a result of
              someone else using your password or account, either with or without your
              knowledge. If you are agreeing to this Agreement on behalf of a company
              or other legal entity, you represent and warrant that you have the
              authority to bind that company or other legal entity to all material
              terms of this Agreement. You could be held liable for losses incurred by
              OmMuse or another party due to someone else using your account or
              password. You may not use anyone else&apos;s account at any time. Creators
              may only register for one account per person, company, or legal entity.
              OmMuse has the sole discretion in granting or denying any accounts.
            </p>
            <ul>
              <li>
                <strong>Creator Representations and Warranties</strong>
              </li>
            </ul>
            <p>
              Creator providing any Creator Content represents and warrants the
              following: (1) Creator is an independent contractor; (2) Creator shall
              provide all materials and expenses related to the creation of any
              Creator Content; and (3) Creator will in good faith abide by this
              Agreement and all other laws, rules, or regulations regarding the
              Creator Content offered on the Platform.
            </p>
            <ul>
              <li>
                <strong>Creator Content Licensing</strong>
              </li>
            </ul>
            <p>
              As a Creator You may offer any Creator Content for license for sale on
              the Platform as permitted by us. Creator may offer any Creator Content
              subject to the licenses types as described within the Platform and as
              selected by Creator(insert link). Creator is solely responsible for
              selecting any licensing options and for setting any pricing related to
              any Creator Content made available on the Platform. Creator Content is
              subject to the User Content Storage provisions within the TOU and we are
              not responsible for any incomplete, corrupted, lost, destroyed, or
              otherwise deleted Creator Content. Please be aware that we are not
              required to host, display, migrate, or distribute any materials related
              to Your Creator Content and we may refuse to accept or transmit any
              Creator Content submitted by a Creator or any information relating to
              the Creator Content. You agree that You are solely responsible for the
              Creator Content and release us from any liability associated with any
              Creator Content submitted. Any Creator Content found to be in violation
              of this Agreement, the TOU, or that we determine to be harmful to the
              Platform may be modified or removed at our discretion. You must abide by
              all portions of this Agreement and the TOU when using our
              Platform.&nbsp;
            </p>
            <ul>
              <li>
                <strong>Additional Creator Content License</strong>
              </li>
            </ul>
            <p>
              All Creator Content is subject to the User Content provisions and
              licensing rights set forth within the TOU. OmMuse will not have any
              ownership rights in the Creator Content, however, each Creator uploading
              Creator Content to the Platform grants OmMuse and its authorized
              sublicensees and distributors, if any, the worldwide, non-exclusive,
              royalty-free, right and license to: (i) reproduce, distribute, publicly
              perform (including on a through-to-the-audience basis and by means of a
              digital audio transmission), publicly display, create derivate works of,
              communicate to the public, synchronize and otherwise exploit (A) the
              applicable Creator Content on Creator&rsquo;s behalf using any
              technologies or methodologies now known or hereafter developed, and (B)
              use and exploit all associated copyrightable works or metadata,
              including, without limitation, song lyrics and musical notations, album
              cover artwork, photographs, graphics, and descriptive text
              (&ldquo;Artworks&rdquo;) in connection with the Platform; (ii) allow
              Users of the Platform to reproduce the applicable Creator Content and
              Artworks on any and all devices owned or controlled by the User for
              non-commercial or commercial purposes and receive performances and
              displays of same; and (iii) reproduce, use, and publish, and to permit
              others to reproduce, use and publish, the name(s), trademarks,
              likenesses, and personal and biographical materials of the Creator, in
              connection with the Platform.
            </p>
            <ul>
              <li>
                <strong>Additional Responsibilities For Any User Content</strong>
              </li>
            </ul>
            <p>
              The Creator Content is considered User Content as defined by the OmMuse
              TOU, Creator must abide by all provisions set forth in the OmMuse TOU.
              Additionally Creator represents and warrants the following: (1) Creator
              owns or has properly licensed all Creator Content provided; (2) the
              Creator Content does not and will not infringe on any copyright, moral
              right, trademark or other intellectual property right and will not
              violate any right of privacy or right of publicity; (3) the Creator
              Content offered does not violate any US state or federal laws or any
              third party agreements; (4)&nbsp;Creator has the sole, exclusive and
              unencumbered ownership of all rights of every kind and character
              throughout the universe in and to the Creator Content and has clear
              title to any other subsidiary materials contained in the Creator
              Content; (5) Creator has the absolute right to grant to OmMuse, all
              rights, licenses and privileges granted to or vested in OmMuse under
              this Agreement or the TOU; (6) Creator has obtained all clearances and
              paid all monies necessary for OmMuse to exercise the license granted
              herein and there will not be any other rights to be cleared or any
              payments required to be made by OmMuse as a result of any use of the
              Creator Content ; and (7) All of the individuals and entities connected
              with the production of the Creator Content, and all of the individuals
              and entities whose names, voices, photographs, likenesses, appearance,
              works, services and other materials appear or have been used in the
              Creator Content, have authorized and approved Creator&rsquo;s use
              thereof, and OmMuse shall have the right to use all names, voices,
              photographs, likenesses, appearance and performances contained in the
              Creator Content in connection with the exploitation, promotion, and use
              of the license granted within the TOU.
            </p>
            <ul>
              <li>
                <strong>Creator Content Clearance</strong>
              </li>
            </ul>
            <p>
              OmMuse shall not be responsible for performing any clearance related to
              any Creator Content submitted to the Platform. However, OmMuse reserves
              the right to require clearance for any Creator Content submitted and
              reserves the right to perform clearance for any Creator Content at any
              time.
            </p>
            <ul>
              <li>
                <strong>Creators and Users</strong>
              </li>
            </ul>
            <p>
              You acknowledge and agree that any licensing of any Creator Content to
              Users creates a direct contractual relationship solely between You and
              the User. OmMuse is not responsible or liable for the actions or
              inactions of a User in relation to You, Your activities, or any Creator
              Content licensed. OmMuse is not a party to any contracts entered between
              You and any Users for any Creator Content. You shall have the sole
              responsibility for any obligations or liabilities to Users or third
              parties that arise from Your licensing of any Creator Content. Creator
              acknowledges and agrees that You are solely responsible for taking any
              and all precautions as may be reasonable and proper (including
              maintaining adequate insurance that meets the requirements of all
              applicable laws) regarding any acts or omissions of a User or third
              party regarding any Creator Content licensed. You acknowledge and agree
              that OmMuse may release Your contact information to Users in the event
              of a dispute related to any Creator Content. Any disputes between
              Creator and User shall be solely resolved between the parties and OmMuse
              shall not be a party to any such disputes.
            </p>
            <ul>
              <li>
                <strong>Re-Downloads</strong>
              </li>
            </ul>
            <p>
              You acknowledge and agree that OmMuse may redistribute copies of any
              Creator Content at no charge to Users who have previously purchased
              Creator Content from You and, in OmMuse&rsquo;s sole determination,
              received a corrupted copy of the applicable Creator Content, an
              incorrect file format version of the applicable Creator Content, an
              incomplete copy of the applicable Creator Content, or suffered a loss of
              the applicable Creator Content through hard drive failure, damage, theft
              or destruction. Applicable Users will also be permitted to re-download
              any previously purchased Creator Content at no additional cost.
            </p>
            <ul>
              <li>
                <strong>Termination of Creator Accounts</strong>
              </li>
            </ul>
            <p>
              We may terminate or suspend your account if we determine that: (1) you
              have violated any applicable laws while using our Platform; (2) If you
              have violated this Agreement or any other of our Platform policies; (3)
              if we believe your actions while using the Platform have harmed or will
              harm a third party, (4) where you have failed consistently perform any
              Creator Content in a satisfactory manner as reported by Users; or (5) if
              we believe that any of your actions may harm OmMuse, at our sole
              decision or discretion. In the event of termination, we will strive to
              provide you with a timely explanation; however, we are not required to
              do so. As a Creator if you wish to terminate your Creator account please
              notify us or use your account dashboard to terminate the account. Please
              be aware that once your account is terminated, all access and
              information including Creator Content in your existing account may
              become immediately inaccessible or deleted, where this occurs we shall
              have no liability to you. Failure to terminate your account for any
              reason does not act as a waiver of your conduct. Upon termination, all
              portions of this Agreement shall survive in accordance with the survival
              provisions of this Agreement. Upon termination of this Agreement for any
              reason, Creator shall complete any outstanding Creator Content
              previously booked on the Platform and OmMuse shall pay Creator for all
              previously booked and properly provided Creator Content in accordance
              with the payment provisions.
            </p>
            <ul>
              <li>
                <strong>&nbsp;Payments From Users</strong>
              </li>
            </ul>
            <p>
              Creator acknowledges and agrees that the Creator fee (&ldquo;Licensing
              Fee&rdquo;) is the only payment You will receive in connection with the
              licensing of Creator Content on the Platform. A full explanation of
              Licensing Fees for any Creator Content can be found within the Platform
              at (insert link). Creator agrees that OmMuse cannot compel any Users to
              make payments and as such OmMuse shall not be responsible for any unpaid
              or partial payments made by Users. Both the Creators and OmMuse agree
              that no agency relationship is formed between OmMuse and Creator in the
              collection of any Licensing Fees.
            </p>
            <ol>
              <li>
                <strong>Payments</strong>
              </li>
            </ol>
            <p>
              Once payment for any licensed Creator Content has been received, OmMuse
              shall hold such payments for a reasonable period of time. After such
              time period, Creator shall be issued payment, by our third party payment
              processor, in the method provided for by OmMuse within a reasonable time
              period and where such Licensing Fees are requested from Creator. Where a
              third party processor issues payment for OmMuse, Creator must agree to
              that third party processor&rsquo;s payment policies before any payments
              may be rendered. Creator is solely responsible for ensuring that any
              accounts set up to receive any Licensing Fees are properly configured.
              OmMuse shall not be responsible for verifying Creator&rsquo;s payment
              method or failure by any third party payment processor to deliver any
              Licensing Fees to Creator. OmMuse shall deduct a service fee, processing
              fees, taxes and other deductions (&ldquo;OmMuse Fee&rdquo;) as necessary
              from all payments made to Creator. More information regarding the OmMuse
              Fee can be found in the Creator&rsquo;s account dashboard or [insert
              link]. OmMuse reserves the right to change and alter any OmMuse Fees at
              any time, if OmMuse alters such OmMuse Fee. In the event of a dispute
              between Creator and OmMuse or Creator and a third party, or where OmMuse
              believes that Creator has violated this Agreement or relevant laws,
              Creator agrees that OmMuse may withhold all Licensing Fees until such
              dispute is resolved.&nbsp;
            </p>
            <ul>
              <li>
                <strong>Cancellations and Refunds</strong>
              </li>
            </ul>
            <p>
              Where a User charges-back, cancels, or otherwise fails to pay for any
              Creator Content (collectively a &ldquo;Chargeback&rdquo;), OmMuse shall
              not be responsible for paying Creator any Licensing Fees for any
              Chargebacks. Where there is an unresolved issue with a User, Creator
              agrees that we may charge its payment method on file or withhold future
              Licensing Fee payments for such unresolved issues.
            </p>
            <ul>
              <li>
                <strong>Offset</strong>
              </li>
            </ul>
            <p>
              OmMuse from time to time may offset, change, remove, or withhold any
              amounts within a Creator&rsquo;s account or otherwise adjust any amounts
              held (collectively &ldquo;Account Adjustment&rdquo;), at its discretion
              and without notice. Creator authorizes OmMuse&rsquo;s ability to make
              any Account Adjustments to its account as necessary to provide the
              payment services to Creator. Such Account Adjustments may be made due to
              a chargeback, reversal, or a request for a refund from a User. Where
              such Account Adjustment requires Licensing Fees to be credited back to
              Creator&rsquo;s account, OmMuse shall only credit to Creator such
              Licensing Fees where an Account Adjustment was made solely due to an
              act, error, or omission of OmMuse. OmMuse shall not be liable for any
              other return of Licensing Fees associated to an Account Adjustment and
              such Licensing Fees shall only be credited at OmMuse&rsquo;s
              discretion.&nbsp;
            </p>
            <ul>
              <li>
                <strong>Tax Documents and Taxes</strong>
              </li>
            </ul>
            <p>
              In order for OmMuse to comply with US tax laws, Creators may be required
              to submit W-9 forms, 1099 forms, or other tax documents. Creator agrees
              to comply with any requests to submit any tax documentation, as
              requested by OmMuse and shall reasonably assist OmMuse with any requests
              related to its tax compliance. Creator agrees that OmMuse cannot and
              will not provide Creator with any tax advice, any such questions should
              be directed to Creator&rsquo;s tax attorney or other tax professional.
              OmMuse at its discretion may withhold any portion of the Licensing Fees,
              in its sole discretion to comply with any state or federal withholding
              requirements. Where OmMuse does not withhold any taxes, You agree to
              timely pay such taxes as required and provide OmMuse with verification
              of such timely payment.
            </p>
            <ol>
              <li>
                <strong>Creator Account Holds</strong>
              </li>
            </ol>
            <p>
              From time to time, OmMuse may place a hold (&ldquo;Hold&rdquo;) on a
              Creator&rsquo;s account. Some of the reasons that we may place a Hold on
              Creator&rsquo;s account include but are not limited to the following:
              (1) if we have reason to believe that your Creator Content or your
              actions have violated this Agreement, may harm our business, are
              deceptive, misleading, unlawful, or have harmed a third party or
              interfere with a third party contractual right; (2) at the request of
              our payment processors; or (3) if required in order to comply with a
              court order, subpoena, writ, injunction, or as otherwise required under
              applicable laws and regulations. If you have questions about a Hold we
              may have placed on your account, or need information about how to
              resolve the Hold, please contact us. Additionally, we may suspend
              Creator&rsquo;s access to the Platform or the offering of any Creator
              Content while such Hold is in place.
            </p>
            <ol>
              <li>
                <strong>Creator Inactivity</strong>
              </li>
            </ol>
            <p>
              Where Creator has not accessed its profile for an extended period of
              time, OmMuse may suspend, make inactive, or otherwise archive
              Creator&rsquo;s account (&ldquo;Inactive Account&rdquo;). If Creator
              wishes to reactivate the Inactive Account they must contact OmMuse at
              info@ommuse.com.
            </p>
            <ol>
              <li>
                <strong>Account Maintenance</strong>
              </li>
            </ol>
            <p>
              Where a Creator has an Inactive Account, OmMuse may maintain the account
              at its discretion. However, any Inactive Accounts may be removed or
              deleted at the sole discretion of OmMuse. Where Creator has an Inactive
              Account, OmMuse shall have no liability to Creator in relation to any
              loss of materials from such Inactive Account and shall have no duty to
              maintain any Inactive Account.
            </p>
            <ol>
              <li>
                <strong>Disclaimer</strong>
              </li>
            </ol>
            <p>
              OMMUSE PROVIDES THE PLATFORM AND ANY RELATED SERVICES ON AN &ldquo;AS IS&rdquo; AND
              &ldquo;AS AVAILABLE&rdquo; BASIS. OMMUSE DOES NOT REPRESENT, WARRANT OR GUARANTEE
              THAT YOUR ACCESS TO OR USE OF THE PLATFORM: (A) WILL BE UNINTERRUPTED,
              VIRUS FREE, AVAILABLE AT ALL TIMES, OR ERROR FREE; OR (B) WILL RESULT IN
              THE BOOKING OF ANY CREATOR CONTENT PROVIDED. OMMUSE FUNCTIONS SOLELY TO
              ASSIST IN SCHEDULING CREATOR CONTENT, OMMUSE MAKES NO WARRANTIES OR
              GUARANTEES AS TO THE ACTIONS OR INACTIONS OF THE USERS WHO MAY REQUEST
              OR USE THE CREATOR CONTENT FROM YOU, AND OMMUSE DOES NOT SCREEN OR
              OTHERWISE EVALUATE USERS. YOU ARE ADVISED TO TAKE REASONABLE PRECAUTIONS
              WITH RESPECT TO INTERACTIONS WITH THIRD PARTIES ENCOUNTERED IN
              CONNECTION WITH THE USE OF THE CREATOR CONTENT OR THIS PLATFORM.
              NOTWITHSTANDING OMMUSE&rsquo;S APPOINTMENT AS THE LIMITED PAYMENT AGENT
              FOR THE PURPOSE OF ACCEPTING PAYMENT FROM USERS ON YOUR BEHALF AS SET
              FORTH IN THIS AGREEMENT, OMMUSE DISCLAIMS ALL LIABILITY FOR ANY ACT OR
              OMISSION BY YOU, ANY USER OR OTHER THIRD PARTY. OMMUSE MAKES NO
              WARRANTIES, EXPRESS OR IMPLIED, BY OPERATION OF LAW OR OTHERWISE, AND
              EXPRESSLY DISCLAIM ALL WARRANTIES, EXPRESS, IMPLIED OR STATUTORY,
              INCLUDING WITHOUT LIMITATION ANY WARRANTIES OF TITLE, NONINFRINGEMENT,
              MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE. ADDITIONALLY,
              OMMUSE DOES NOT REPRESENT OR WARRANT ANY INFORMATION WILL BE CORRECT,
              COMPLETE, OR ACCURATE. SOME JURISDICTIONS LIMIT THE ABILITY TO DISCLAIM
              ALL WARRANTIES, SO THIS CLAUSE OR SOME PORTIONS OF THIS CLAUSE MAY NOT
              APPLY TO YOU.&nbsp;
            </p>
            <ol>
              <li>
                <strong>Limitations of Liability</strong>
              </li>
            </ol>
            <p>
              OMMUSE NOT BE LIABLE UNDER OR RELATED TO THIS AGREEMENT FOR ANY OF THE
              FOLLOWING, WHETHER BASED ON CONTRACT, TORT OR ANY OTHER LEGAL THEORY,
              INCLUDING NEGLIGENCE, EVEN IF A PARTY HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES: (A) ANY INCIDENTAL, PUNITIVE, SPECIAL,
              EXEMPLARY, CONSEQUENTIAL, OR OTHER INDIRECT DAMAGES OF ANY TYPE OR KIND;
              OR (B) YOUR OR ANY THIRD PARTY&rsquo;S PROPERTY DAMAGE, OR LOSS OR
              INACCURACY OF DATA, OR LOSS OF BUSINESS, REVENUE, PROFITS, USE OR OTHER
              ECONOMIC ADVANTAGE. EXCEPT FOR COMPANY&rsquo;S OBLIGATIONS TO PAY
              AMOUNTS DUE TO YOU PURSUANT TO OUR PAYMENTS SECTION, BUT SUBJECT TO ANY
              LIMITATIONS OR OTHER PROVISIONS CONTAINED IN THIS AGREEMENT WHICH ARE
              APPLICABLE THERETO, IN NO EVENT SHALL THE LIABILITY OF OMMUSE UNDER THIS
              AGREEMENT EXCEED THE AMOUNT OF FEES ACTUALLY PAID TO OR DUE TO CREATOR
              HEREUNDER IN THE SIX (6) MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT
              GIVING RISE TO SUCH CLAIM OR ONE HUNDRED ($100) USD. CREATOR IS NOTIFIED
              THAT ADDITIONAL LIMITATIONS OF LIABILITY ARE STATED WITHIN THE TOU.
            </p>
            <ol>
              <li>
                <strong>Class Action Waiver</strong>
              </li>
            </ol>
            <p>
              YOU UNDERSTAND AND AGREE THAT YOU AND OMMUSE MAY EACH BRING CLAIMS IN
              ARBITRATION AGAINST THE OTHER ONLY IN AN INDIVIDUAL CAPACITY AND NOT ON
              A CLASS, COLLECTIVE ACTION, OR REPRESENTATIVE BASIS (&ldquo;CLASS ACTION
              WAIVER&rdquo;). YOU UNDERSTAND AND AGREE THAT YOU AND OMMUSE BOTH ARE
              WAIVING THE RIGHT TO PURSUE OR HAVE A DISPUTE RESOLVED AS A PLAINTIFF OR
              CLASS MEMBER IN ANY PURPORTED CLASS, COLLECTIVE OR REPRESENTATIVE
              PROCEEDING. NOTWITHSTANDING THE FOREGOING, THIS SUBSECTION (B) SHALL NOT
              APPLY TO REPRESENTATIVE PRIVATE ATTORNEYS GENERAL ACT CLAIMS BROUGHT
              AGAINST OMMUSE, WHICH ARE ADDRESSED SEPARATELY.
            </p>
            <p>
              Notwithstanding any other provision of this Agreement, the Arbitration
              provisions or any associated rules or the, disputes regarding the scope,
              applicability, enforceability, revocability or validity of the Class
              Action Waiver may be resolved only by a civil court of competent
              jurisdiction and not by an arbitrator. In any case in which: (1) the
              dispute is filed as a class, collective, or representative action and
              (2) there is a final judicial determination that the Class Action Waiver
              is unenforceable as to any Disputes (defined below), the class,
              collective, and/or representative action on such Disputes must be
              litigated in a civil court of competent jurisdiction, but the Class
              Action Waiver shall be enforced in arbitration on an individual basis as
              to all other Claims to the fullest extent possible.
            </p>
            <ol>
              <li>
                <strong>Arbitration</strong>
              </li>
            </ol>
            <p>
              This Agreement and any dispute arising out of or in connection with this
              Agreement (&ldquo;Dispute&rdquo;) will be governed as to all matters,
              including, but not limited to the validity, construction and performance
              of this Agreement, by and under the laws of the state of Florida,
              without giving effect to conflict of laws principles thereof.&nbsp;
            </p>
            <p>Binding Arbitration</p>
            <p>
              You agree that any dispute relating in any way to your use of the
              Platform shall be submitted to confidential binding arbitration.
              &nbsp;If there is a dispute about whether this arbitration provision can
              be enforced or applies to the Dispute, You and OmMuse agree that the
              arbitrator will decide that issue. However, any claim that all or part
              of this Class Action Waiver is unenforceable, unconscionable, void or
              voidable may be determined only by a court of competent jurisdiction and
              not by an arbitrator.
            </p>
            <p>
              Arbitration under this Agreement is under the Federal Arbitration Act
              which governs the interpretation and enforcement of this provision. The
              arbitration will be administered by JAMS Arbitration in accordance with
              their commercial rules (the &ldquo;Rules&rdquo;) then in effect, except
              as modified here. Arbitration shall be conducted by one (1) arbitrator
              as selected pursuant to the Rules; the arbitrator&apos;s award shall be final
              and binding and may be entered as a judgment in any court of competent
              jurisdiction. The location of the arbitration shall be Parkland, FL.
              Where a Dispute does not exceed $15,000 such Dispute shall be arbitrated
              solely via pleadings and documents. Each party shall be responsible for
              their own arbitration fees and costs. To the fullest extent permitted by
              applicable law, no arbitration under this Agreement shall be joined to
              an arbitration involving any other party subject to this Agreement,
              whether through class action proceedings or otherwise. You agree that
              regardless of any statute or law to the contrary, any claim or cause of
              action arising out of, related to or connected with the use of the
              Platform or this Agreement must be filed within one (1) year after such
              claim or cause of action arose or be forever banned. Each party shall be
              responsible for their own costs. In the event that the law does not
              permit the abovementioned dispute to be resolved through arbitration,
              you agree that any actions shall be brought solely in a court of
              competent jurisdiction located within or otherwise nearest to Broward
              County, FL.
            </p>
            <p>Opt-Out</p>
            <p>
              Creator has the right to opt out of binding arbitration within thirty
              (30) days of the date You first accepted this Agreement by notifying us
              via mail at 12177 NW 69th Ct. Parkland, FL 33076. In order to be
              effective, the opt out notice must include Your full name, any account
              information, and must clearly indicate Your intent to opt out of binding
              arbitration. If You have decided to opt-out of Binding Arbitration, all
              Disputes shall be heard in a court of competent jurisdiction located
              within Broward County, FL
            </p>
            <p>Exceptions to Arbitration</p>
            <p>
              Creator agrees that all Disputes shall be arbitrated, except for as
              provided above and as follows: (i) Any claim related to actual or
              threatened infringement, misappropriation or violation of a
              party&rsquo;s copyrights, trademarks, trade secrets, patents, or other
              intellectual property rights; (ii) Any claim seeking emergency
              injunctive relief based on exigent circumstances such as, imminent
              danger or commission of a crime. Such claims shall be brought before a
              judicial proceeding in a court of competent jurisdiction located within
              Broward County, FL.
            </p>
            <ol>
              <li>
                <strong>Indemnification</strong>
              </li>
            </ol>
            <p>
              You agree to release, defend, indemnify, and hold OmMuse and its
              affiliates and subsidiaries, and their officers, directors, employees
              and agents, harmless from and against any claims, liabilities, damages,
              losses, and expenses, including, without limitation, reasonable legal
              and accounting fees, arising out of or in any way connected with (1)
              Your breach of this Agreement, (2) Your improper use of the OmMuse
              Platform or any services provided, (3) Your interaction with any User,
              Creator, or other third party including without limitation any injuries,
              losses or damages of any kind arising in connection with or as a result
              of such interaction, (4) Your breach of any laws, regulations or third
              party rights. You agree that this indemnity extends to requiring You to
              pay for our reasonable attorneys&rsquo; fees, court costs, and
              disbursements. In the event of a claim such as one described in this
              paragraph, we may elect to choose counsel and settle with the
              party/parties making the claim and You shall be liable for the damages
              as though we had proceeded with a trial.
            </p>
            <ul>
              <li>
                <strong>Survival</strong>
              </li>
            </ul>
            <p>
              All provisions of this Agreement which by their nature should survive
              termination shall survive termination, including, without limitation of
              liability, disclaimer, indemnification, payment provisions, arbitration,
              dispute, termination, and class action waivers, and ownership
              provisions.
            </p>
            <ul>
              <li>
                <strong>Severability</strong>
              </li>
            </ul>
            <p>
              In the event that a provision of this Agreement is found to be unlawful,
              conflicting with another provision of the Agreement, or otherwise
              unenforceable, the Agreement will remain in force as though it had been
              entered into without that unenforceable provision being included in it.
            </p>
            <p>
              If two or more provisions of this Agreement or any other agreement You
              may have with OmMuse are deemed to conflict with each other&rsquo;s
              operation, You agree that OmMuse shall have the sole right to elect
              which provision remains in force.
            </p>
            <ul>
              <li>
                <strong>Assignment</strong>
              </li>
            </ul>
            <p>
              You may not assign Your rights and/or obligations under this Agreement
              to any other party without our prior written consent. We may assign our
              rights and/or obligations under this Agreement to any other party at our
              discretion.
            </p>
            <ul>
              <li>
                <strong>Amendments</strong>
              </li>
            </ul>
            <p>
              We may amend this Agreement from time to time. When we amend this
              Agreement, we will update this page and indicate the date that it was
              last modified or we may email You. You may refuse to agree to the
              amendments, but if You do, You must immediately cease using our
              Platform.&nbsp;
            </p>
            <ol>
              <li>
                <strong>Waiver</strong>
              </li>
            </ol>
            <p>
              We reserve all rights permitted to us under this Agreement as well as
              under the provisions of any applicable law. Our non-enforcement of any
              particular provision or provisions of this Agreement or any applicable
              law should not be construed as our waiver of the right to enforce that
              same provision under the same or different circumstances at any time in
              the future.
            </p>
            <ol>
              <li>
                <strong>Force Majeure</strong>
              </li>
            </ol>
            <p>
              OmMuse will not be liable or responsible for any delays in service, for
              failing to provide any services or to operate the Platform as a result
              of any event beyond its reasonable control, including, without
              limitation, adverse weather conditions, internet outage or interruption
              of service, power or telecommunications outage, fire, flood, civil
              disobedience, labor disruptions, strikes, contagion, lockouts, freight
              embargoes, terrorism, natural disaster, war or acts of God.
            </p>
            <ol>
              <li>
                <strong>Entire Agreement</strong>
              </li>
            </ol>
            <p>
              This Agreement along with the TOU and the Privacy Policy form the entire
              Agreement between the parties. Creator is subject to the TOU but where
              this Agreement and the TOU directly and explicitly conflict, this
              Agreement shall supersede.
            </p>
            <ol>
              <li>
                <strong>Contact Information and Notices</strong>
              </li>
            </ol>
            <p>
              Any notices to You shall be sent via your account on the Platform. Any
              notices to OmMuse shall be sent to OmMuse 12177 NW 69th Ct. Parkland, FL
              33076.
            </p>
            <ol>
              <li>
                <strong>Relationship of Parties</strong>
              </li>
            </ol>
            <p>
              Except as expressly provided for otherwise, this Agreement shall not be
              construed to create any association, partnership, joint venture,
              employee, worker or agency relationship between Creator and OmMuse.
              Creator has no authority (and shall not hold himself or herself out as
              having authority) to bind OmMuse and Creator shall not make any
              agreements or representations on OmMuse&apos;s behalf without OmMuse&apos;s prior
              written consent. Creator shall be responsible for, and shall indemnify
              and hold OmMuse harmless for any claims, suits, or actions related to
              this provision, including any such claims brought by Creator or by any
              third party with respect to any claims for taxes or contributions,
              including penalties and interest.
            </p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CreatorAgreement;
